import React from 'react';
import { ArrowRightIcon, RocketIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://surgical-shield-system-2026.impultienda.ar/checkout';
interface CtaButtonProps {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  /** Defaults to scrolling to the offer section; pass CHECKOUT_URL to go straight to payment. */
  href?: string;
  /** 'primary' works on light backgrounds, 'light' on the dark offer card. */
  variant?: 'primary' | 'light';
  fullWidth?: boolean;
  /** Identifies which CTA on the page was clicked, sent to the Meta Pixel. */
  source?: string;
}
export function CtaButton({
  label = 'Get My Surgical Shield System',
  size = 'lg',
  className = '',
  href = '#offer',
  variant = 'primary',
  fullWidth = false,
  source = 'cta'
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  const sizing = size === 'lg' ? 'px-6 py-3.5 text-sm sm:px-8 sm:py-4 sm:text-lg' : 'px-5 py-3 text-sm sm:text-base';
  const tone = variant === 'light' ? 'bg-cream-50 text-forest-800 hover:bg-white focus-visible:outline-cream-50' : 'bg-ember-500 text-white hover:bg-ember-600 focus-visible:outline-ember-500';
  return <a href={href} onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: 'Surgical Shield System 2026',
    content_category: source,
    value: 27,
    currency: 'USD'
  })} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex items-center justify-center gap-2.5 rounded-full font-semibold uppercase tracking-wide shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${sizing} ${tone} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-52" data-mp="3ex2mvkxorwzn">
      {variant === 'light' ? null : <RocketIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="3mx7c3a6pxigo" />}
      {label}
      {variant === 'light' ? <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="3hymeliiupcvx" /> : null}
    </a>;
}